import type { ProviderDetail } from '../../../../../js/api';
import { CREDENTIAL_SECTIONS, CredentialSectionSpec, rowInSection } from './credentials';

/**
 * How many of a tab's REQUIRED sections (Licenses & Certs: medical license, DEA, board
 * certification, life-support certification; Immunizations: TB, flu) have no ENTRY for
 * this clinician. An entry without its document is flagged on its card, not here.
 *
 * Reads the credential rows nested on the detail payload the drawer already holds
 * (one prefetched query) rather than the tabs' list endpoints, so opening the drawer
 * on any tab costs nothing extra; every credential mutation invalidates the detail, so
 * the flag stays current. Null detail (still loading) is never flagged.
 */
export function countMissingRequiredCredentials(
  provider: ProviderDetail | undefined,
  sections: readonly CredentialSectionSpec[] = CREDENTIAL_SECTIONS
): number {
  if (!provider) return 0;
  const rowsByKind = {
    license: provider.licenses ?? [],
    board: provider.board_certifications ?? [],
    life: provider.certifications ?? [],
    immunization: provider.immunizations ?? [],
    ecfmg: provider.ecfmg_certificates ?? [],
  };
  return sections.filter(
    (section) =>
      section.required && !rowsByKind[section.kind].some((row) => rowInSection(row, section))
  ).length;
}
